import { render, staticRenderFns } from "./TermDialog.vue?vue&type=template&id=1cd42e0a&scoped=true"
import script from "./TermDialog.vue?vue&type=script&lang=js"
export * from "./TermDialog.vue?vue&type=script&lang=js"
import style0 from "./TermDialog.vue?vue&type=style&index=0&id=1cd42e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd42e0a",
  null
  
)

export default component.exports